import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { SiteDiaryService,SiteDiaryItem} from '../services/SiteDiary.service';


@Component({
  selector: 'SiteDiary-Details',
  templateUrl: './SiteDiary-Details.component.html',
  styleUrls: ['./SiteDiary-Details.component.sass']
})
export class SiteDiaryDetailsComponent implements OnInit, OnChanges {
  
  @Input() siteDiaryPermission: any
  @Output() submitButton = new EventEmitter();


  public divClick = 'summary'
  public addActivty = false
  public updataActivty = null
  public summaryData:SiteDiaryItem 
  public showLoading: boolean = false
  public isEdit:boolean = false
  public currentUser:any=document.querySelector('meta[name=current_user]')

  public objectKeys = Object.keys;

  constructor(
    public service: SiteDiaryService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.updateEditState();
    this.loadSiteDiaryData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['siteDiaryPermission'] && !changes['siteDiaryPermission'].firstChange) {
      console.log('siteDiaryPermission changed:', changes['siteDiaryPermission'].currentValue);
      this.updateEditState();
      this.cdr.detectChanges();
    }
  }

  private updateEditState() {
    if (this.siteDiaryPermission && this.siteDiaryPermission.update !== undefined) {
      // 如果没有更新权限，则设置为只读模式（isEdit = true表示只读）
      this.isEdit = !this.siteDiaryPermission.update;
      console.log('Updated isEdit state:', this.isEdit, 'based on update permission:', this.siteDiaryPermission.update);
    }
  }

  private loadSiteDiaryData() {
    let locationData = window.location.search.replace('?','?&',).split('&')
    locationData.forEach((res,index)=>{
      if(res === '?') return
      let itemdata = res.split('=')
      if(itemdata[0] === 'siteDiary'){
        this.service.siteDiaryShow({site_diary_id:itemdata[1]}).subscribe((res:SiteDiaryItem)=>{
          //console.log(res)
          this.summaryData = res
          console.log(this.siteDiaryPermission,'siteDiaryPermission')
          // 移除重复的状态更新逻辑，统一由updateEditState()方法处理
          this.updateEditState();
        })
      }
    })
  }

  //分类按钮
  classificationClick(value:any){
    this.divClick = value
  }

  //添加Activty
  addActivtyClick(){
    this.updataActivty=null
    this.addActivty = !this.addActivty
    jQuery('#top-menu').css('z-index','unset')

  }

  //table修改按钮
  tableEdit(data:any){
    //console.log(data)
    this.updataActivty = data
    this.addActivty = !this.addActivty
  }

  //提交按钮
  submitClick(){
    //console.log(this.summaryData)
    let data:any = this.summaryData
    data['site_diary_id'] = this.summaryData.id
    this.showLoading = true
    this.service.updataSiteDiaryShow(data).subscribe((res)=>{
      //console.log(res)
      window.history.replaceState(null, '', `${window.location.origin}${window.location.pathname}`)
      let from = this.getQueryString('from')
      if(from === 'my_action'){
        window.history.back()
      }else{
        this.submitButton.emit()
      }
      this.showLoading = false
    },(error:any)=>{
      alert(error.error.error)
      this.showLoading = false
    })

  }
  getQueryString(name:any) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const queryString = window.location.href.split('?')[1];
    if (!queryString) {
      return null;
    }
    let url = queryString.match(reg);
    if (url != null) {
      return decodeURI(url[2]);
    } else {
      return null;
    }
  }
  //取消按钮
  closeClick(){
    let from = this.getQueryString('from')
    if(from === 'my_action'){
      window.history.back()
    }else{
      window.history.replaceState(null, '', `${window.location.origin}${window.location.pathname}`)
    }
    this.submitButton.emit()
  }

}
